import './App.css';
import 'primeicons/primeicons.css';
import "chart.js/auto";
import RoutesPath from './routes/routes';
import { LoginContext } from './context/LoginContext';
import { useState } from 'react';
import webLogin from './types/webLogin';

function App() {
    const [ webLoginContextValue, setWebLoginContextValue ] = useState(new webLogin());
    const dataLoginData = { webLoginContextValue , setWebLoginContextValue };
  
    return (
        <LoginContext.Provider value={dataLoginData}>
            <RoutesPath />
        </LoginContext.Provider>
    );
}

export default App;
